import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Comment {
  id: number;
  user: string;
  avatar: string;
  content: string;
  time: string;
  likes: number;
}

const mockComments: Comment[] = [
  {
    id: 1,
    user: '吃瓜群众一号',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20portrait%20minimal%20dark%20background%20simple%20style&width=80&height=80&seq=cmt-avatar-01&orientation=squarish',
    content: '我的天，这也太劲爆了吧！直播带货的水也太深了，以后都不敢在直播间买东西了...',
    time: '10分钟前',
    likes: 1283,
  },
  {
    id: 2,
    user: '不八卦会死星人',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20avatar%20portrait%20minimal%20dark%20background%20simple%20style&width=80&height=80&seq=cmt-avatar-02&orientation=squarish',
    content: '早就觉得这个主播不对劲了，天天卖的东西价格低得离谱，果然有问题！支持品牌方维权！',
    time: '25分钟前',
    likes: 967,
  },
  {
    id: 3,
    user: '理性吃瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20person%20avatar%20portrait%20minimal%20dark%20background%20simple%20style&width=80&height=80&seq=cmt-avatar-03&orientation=squarish',
    content: '建议大家在事情调查清楚之前不要跟风网暴，等官方通报吧。不过话说回来，这波实锤确实够狠的...',
    time: '40分钟前',
    likes: 542,
  },
  {
    id: 4,
    user: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20adult%20avatar%20portrait%20minimal%20dark%20background%20simple%20style&width=80&height=80&seq=cmt-avatar-04&orientation=squarish',
    content: '每天最大的快乐就是来51暗网吃瓜，比追剧还刺激！小编加油更新啊！',
    time: '1小时前',
    likes: 876,
  },
  {
    id: 5,
    user: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20adult%20avatar%20portrait%20minimal%20dark%20background%20simple%20style&width=80&height=80&seq=cmt-avatar-05&orientation=squarish',
    content: '今年塌房的网红真是一个接一个，这行业该好好整治了。建议平台方提高准入门槛...',
    time: '1小时前',
    likes: 432,
  },
  {
    id: 6,
    user: '瓜田里的猹',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20portrait%20minimal%20dark%20background%20fun%20style&width=80&height=80&seq=cmt-avatar-06&orientation=squarish',
    content: '猹来了！作为资深吃瓜人，这个网站简直是我的快乐源泉！收藏了收藏了！',
    time: '2小时前',
    likes: 654,
  },
];

export default function TrendingSection() {
  const [activeTab, setActiveTab] = useState<'hot' | 'latest'>('hot');

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-1.5 h-5 rounded-full bg-secondary-500"></span>
            <span className="text-xs font-medium text-foreground-400 font-label tracking-widest uppercase">
              COMMUNITY
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            网友热议
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/30 w-fit mb-6">
              <button
                onClick={() => setActiveTab('hot')}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                  activeTab === 'hot'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
              >
                最热评论
              </button>
              <button
                onClick={() => setActiveTab('latest')}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                  activeTab === 'latest'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
              >
                最新评论
              </button>
            </div>

            <div className="flex flex-col gap-4">
              {mockComments.map((comment) => (
                <div
                  key={comment.id}
                  className="p-4 rounded-lg bg-background-100 border border-background-200/30"
                >
                  <div className="flex items-center gap-3 mb-2.5">
                    <img
                      src={comment.avatar}
                      alt={comment.user}
                      className="w-8 h-8 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground-800">{comment.user}</p>
                      <p className="text-xs text-foreground-500">{comment.time}</p>
                    </div>
                    <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes}</span>
                    </button>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/30 flex-1">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-fire-fill text-accent-500 text-lg"></i>
                <h3 className="text-sm font-semibold text-foreground-700 font-label tracking-wide uppercase">
                  吃瓜指南
                </h3>
              </div>
              <ul className="flex flex-col gap-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-400">1</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800 mb-1">保持理性吃瓜</p>
                    <p className="text-xs text-foreground-500 leading-relaxed">在事情没有官方定论之前，不要盲目站队或跟风网暴。</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-400">2</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800 mb-1">多渠道核实信息</p>
                    <p className="text-xs text-foreground-500 leading-relaxed">不要只相信单一来源的爆料，多对比几个渠道再下结论。</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-400">3</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800 mb-1">文明参与讨论</p>
                    <p className="text-xs text-foreground-500 leading-relaxed">发表观点时注意文明用语，拒绝人身攻击和网络暴力。</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-400">4</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800 mb-1">投稿吃瓜爆料</p>
                    <p className="text-xs text-foreground-500 leading-relaxed">如果你有第一手黑料信息，欢迎通过邮箱联系我们投稿！</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="p-5 md:p-6 rounded-xl bg-gradient-to-br from-primary-500/10 to-accent-500/10 border border-primary-500/20">
              <div className="flex items-center gap-3 mb-3">
                <i className="ri-megaphone-fill text-primary-500 text-xl"></i>
                <h3 className="text-sm font-semibold text-foreground-700 font-label tracking-wide uppercase">
                  爆料投稿
                </h3>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                你有网红主播的第一手黑料？欢迎向我们投稿！严格保护爆料人隐私。
              </p>
              <Link
                to="/about"
                className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer"
              >
                联系我们
                <i className="ri-send-plane-fill"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}